import { Box } from '@material-ui/core';
import styled, { css } from 'styled-components';

export const Wrapper = styled(Box)`
    ${({ theme }) => css`
        height: calc(100vh - 92px);
    `}
`;
